export default "__VITE_ASSET__2aba14e0__"